var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _g3, _g4, _g5, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 206,
    viewBox: "0 0 193 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M96.5 206C149.795 206 193 200.496 193 193.708C193 186.919 149.795 181.416 96.5 181.416C43.2045 181.416 0 186.919 0 193.708C0 200.496 43.2045 206 96.5 206Z",
    fill: "#C9D3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.298 28.5596H25.0371V142.419H172.298V28.5596Z",
    fill: "#C9D3DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.314 37.0503H36.021V133.924H161.314V37.0503Z",
    fill: "#29333D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.304 87.0298H130.302V133.928H136.304V87.0298Z",
    fill: "#C9D3DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.123 28.5596H163.818V29.4703L143.97 63.3609H133.913L124.123 28.5596Z",
    fill: "#29333D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6582 67.6813L68.7749 72.2695L99.8482 98.6934L103.731 94.1051L72.6582 67.6813Z",
    fill: "#C9D3DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.925 84.4987L131.688 89.5654L162.199 109.154L165.436 104.088L134.925 84.4987Z",
    fill: "#C9D3DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0042 134.237H89.0015V107.836L107.697 84.0216H130.302V55.8716H136.305V90.0386H110.612L95.0042 109.92V134.237Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7186 72.9888H33.4443V66.9719H67.7159V34.0962H73.7186V72.9888Z",
    fill: "#C9D3DB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.939 57.3031H70.7173V51.2862H102.937V34.0962H108.939V57.3031Z",
    fill: "#C9D3DB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.1358 94.4785L82.1398 99.109L76.3541 110.477L82.1398 112.914L67.35 142.419H40.3242L43.1222 116.929L47.353 109.711L57.9165 94.4785H68.8507H73.1358Z",
    fill: "#29333D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.303 68.232C141.573 68.232 148.278 66.0513 148.278 63.3614C148.278 60.6714 141.573 58.4907 133.303 58.4907C125.032 58.4907 118.328 60.6714 118.328 63.3614C118.328 66.0513 125.032 68.232 133.303 68.232Z",
    fill: "#29333D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.298 22.0445C155.298 9.0456 144.07 -1.32547 130.808 0.137987C120.769 1.24804 112.655 9.30838 111.471 19.3668C110.856 24.5728 112.058 29.4751 114.522 33.5166L133.307 64.367L151.998 33.6661C154.091 30.2907 155.302 26.3126 155.302 22.0491L155.298 22.0445Z",
    fill: "#004E2B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_41323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.429 14.79H129.913C132.347 14.79 134.341 16.7865 134.341 19.2295V22.6141H129.858C127.424 22.6141 125.429 20.6176 125.429 18.1746V14.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.964 24.8043C139.341 24.8043 138.828 24.2931 138.828 23.6653V21.3615H141.695V21.3324C141.695 19.7663 140.416 18.4882 138.857 18.4882H136.559V24.7752H126.281V27.6486H127.417C127.417 28.5869 128.182 29.357 129.121 29.357C130.061 29.357 130.826 28.5902 130.826 27.6486H131.394C131.394 28.5869 132.159 29.357 133.098 29.357C134.038 29.357 134.803 28.5902 134.803 27.6486H137.072C137.072 28.5869 137.837 29.357 138.777 29.357C139.716 29.357 140.481 28.5902 140.481 27.6486H141.617V24.8043H141.701H139.964Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9315 36.0967H35.5273V60.5436H85.9315V36.0967Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9315 60.5435H35.5273V85.8053H85.9315V60.5435Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9315 85.8052H35.5273V110.252H85.9315V85.8052Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9315 110.252H35.5273V135.514H85.9315V110.252Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2648 54.4354C52.6349 54.4354 55.3669 51.6969 55.3669 48.3188C55.3669 44.9407 52.6349 42.2021 49.2648 42.2021C45.8946 42.2021 43.1626 44.9407 43.1626 48.3188C43.1626 51.6969 45.8946 54.4354 49.2648 54.4354Z",
    fill: "#C9D3DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2648 79.3548C52.6349 79.3548 55.3669 76.6163 55.3669 73.2382C55.3669 69.8601 52.6349 67.1216 49.2648 67.1216C45.8946 67.1216 43.1626 69.8601 43.1626 73.2382C43.1626 76.6163 45.8946 79.3548 49.2648 79.3548Z",
    fill: "#C9D3DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2648 104.274C52.6349 104.274 55.3669 101.536 55.3669 98.1576C55.3669 94.7795 52.6349 92.041 49.2648 92.041C45.8946 92.041 43.1626 94.7795 43.1626 98.1576C43.1626 101.536 45.8946 104.274 49.2648 104.274Z",
    fill: "#C9D3DB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2648 128.287C52.6349 128.287 55.3669 125.65 55.3669 122.397C55.3669 119.144 52.6349 116.507 49.2648 116.507C45.8946 116.507 43.1626 119.144 43.1626 122.397C43.1626 125.65 45.8946 128.287 49.2648 128.287Z",
    fill: "#C9D3DB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9673 42.6548H60.3389V46.2794H77.9673V42.6548Z",
    fill: "#C9D3DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9673 67.5742H60.3389V71.1989H77.9673V67.5742Z",
    fill: "#C9D3DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9673 92.4941H60.3389V96.1188H77.9673V92.4941Z",
    fill: "#C9D3DB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9673 116.961H60.3389V120.586H77.9673V116.961Z",
    fill: "#C9D3DB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9392 49.1118H60.1396V53.0347H77.9392V49.1118Z",
    fill: "#C9D3DB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9392 74.0317H60.1396V77.9546H77.9392V74.0317Z",
    fill: "#C9D3DB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9392 98.9512H60.1396V102.874H77.9392V98.9512Z",
    fill: "#C9D3DB"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9392 123.147H60.1396V126.856H77.9392V123.147Z",
    fill: "#C9D3DB"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1343 112.059L57.4777 95.3896L60.357 97.9224L48.9844 116.975L44.1343 112.059Z",
    fill: "#016AD4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0402 84.6061L24.5036 92.0094L18.6591 95.7293L16.5527 82.8979L22.0402 84.6061Z",
    fill: "#F4A28C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5502 75.7438C15.8068 72.6673 19.8884 72.0376 22.1575 74.4661C24.6436 77.1257 27.6449 81.362 24.2503 83.6637C19.0567 87.1887 14.2925 80.6008 14.2925 80.6008C14.2925 80.6008 13.5964 78.0772 14.5502 75.7438Z",
    fill: "#F4A28C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3469 80.2838C18.3469 80.2838 17.018 79.1692 16.4123 80.7505C15.8112 82.3363 18.1616 83.102 18.8622 82.3C19.5628 81.4981 18.3469 80.2793 18.3469 80.2793V80.2838Z",
    fill: "#F4A28C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8383 99.3631C13.6012 95.3896 17.05 92.4128 21.2085 91.1623C29.1504 88.77 43.773 91.3889 48.2298 98.833C54.332 109.027 45.4002 141.409 45.4002 141.409L18.7134 143.484C18.7134 143.484 4.03207 116.943 11.8383 99.3586V99.3631Z",
    fill: "#016AD4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3953 141.409L41.8832 187.402H36.337L31.383 151.667L19.1108 143.489L45.3953 141.409Z",
    fill: "#29333D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1112 143.489L11.4541 187.402H17.4026L30.2533 150.919L19.1112 143.489Z",
    fill: "#29333D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M23.5136 90.4645C23.5136 90.4645 11.0291 130.766 47.077 133.439L45.3955 141.414L18.7087 143.489C18.7087 143.489 9.30689 128.687 9.70466 107.899C9.70466 107.899 9.93066 97.6187 17.1493 93.0743C17.1493 93.0743 19.9066 91.0399 23.5136 90.46V90.4645Z",
    fill: "#29333D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8506 187.307L9.26618 189.953C8.65597 190.406 8.97238 191.38 9.73176 191.38H15.739C16.1729 191.38 16.5255 191.026 16.5255 190.591V187.307H12.8506Z",
    fill: "#016AD4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1916 187.307L44.5636 189.953C45.1602 190.419 44.8303 191.38 44.0709 191.38H39.7949C38.5338 191.38 37.5122 190.356 37.5122 189.092V187.307H41.1871H41.1916Z",
    fill: "#016AD4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3979 90.9492C34.3979 90.9492 29.8145 97.4646 34.3979 105.217C37.3089 110.142 45.775 119.729 51.5653 126.068C54.3813 129.153 59.3851 128.569 61.4192 124.917L73.854 102.942L69.6322 100.233L58.237 116.983C58.237 116.983 50.4398 91.28 34.3979 90.9583V90.9492Z",
    fill: "#016AD4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.3979 90.9492C34.3979 90.9492 29.8145 97.4646 34.3979 105.217C37.3089 110.142 45.775 119.729 51.5653 126.068C54.3813 129.153 59.3851 128.569 61.4192 124.917L73.854 102.942L69.6322 100.233L58.237 116.983C58.237 116.983 50.4398 91.28 34.3979 90.9583V90.9492Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3806 101.995C72.3806 101.995 79.441 99.3946 76.5617 95.3939C73.6824 91.3887 69.6323 100.228 69.6323 100.228L72.3806 101.995Z",
    fill: "#F4A28C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8894 89.9523L73.3488 87.9135C72.845 87.6873 72.2539 87.9127 72.0285 88.4169L68.6868 95.8945C68.4615 96.3987 68.6873 96.9909 69.1911 97.2171L73.7317 99.2559C74.2355 99.4821 74.8266 99.2567 75.0519 98.7525L78.3936 91.2749C78.619 90.7707 78.3932 90.1785 77.8894 89.9523Z",
    fill: "#3D4D5C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9411 85.254L12.986 81.1491C12.1543 80.2883 11.7249 79.1238 11.7836 77.9277C11.8786 75.839 12.3261 72.5133 14.0482 70.0123C16.7513 66.0932 20.3538 64.6116 21.2488 68.0006C22.1438 71.3897 22.3291 67.3663 24.5078 69.1651C26.6865 70.9638 26.239 72.0195 24.5078 72.9755C22.7766 73.9315 19.1876 75.3089 18.8712 78.1678C18.5548 81.0268 21.2533 83.3284 16.9456 85.2495L16.9411 85.254Z",
    fill: "#29333D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1465 95.983C58.1465 95.983 59.0279 89.8709 64.9402 90.4644C70.8525 91.0534 68.6919 92.5667 66.3053 92.68H66.2872C65.2928 92.8748 64.5244 93.6224 64.208 94.5875C63.8599 95.6567 62.8971 97.0477 60.3523 97.9267L58.1465 95.9875V95.983Z",
    fill: "#F4A28C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_41323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2724,
    height: 16.311,
    fill: "white",
    transform: "translate(125.429 14.1104)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1052de4b952fb7789da4fda6922957ea.svg";
export { ForwardRef as ReactComponent };